const DEFAULT_AGG_LEVEL = "24h"
const DEFAULT_DAYS_BACK = 7
const ALL_UTM_SOURCES_OPTION = "All"

export { DEFAULT_AGG_LEVEL, DEFAULT_DAYS_BACK, ALL_UTM_SOURCES_OPTION }
